<template>
	<div class="full page_container">

		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="现结" v-if="findChildren(77)!==-1" name="reconciliationcurrent" style="height: 100%;">
				<reconciliationcurrent-index />
			</el-tab-pane>
			<el-tab-pane label="月结" v-if="findChildren(78)!==-1" name="reconciliation" style="height: 100%;">
				<reconciliation-index />
			</el-tab-pane>
			<el-tab-pane label="月结付款单" v-if="findChildren(82)!==-1" name="reconciliationpay" style="height: 100%;">
				<reconciliationpay-index />
			</el-tab-pane>
			<el-tab-pane label="月结对账" v-if="findChildren(110)!==-1" name="reconciliationbill" style="height: 100%;">
				<reconciliationbill-index />
			</el-tab-pane>
			<el-tab-pane label="采购入库单" v-if="findChildren(101)!==-1" name="purchasestockbill" style="height: 100%;">
				<purchasestockbill-index />
			</el-tab-pane>
			<el-tab-pane label="采购出库单" v-if="findChildren(103)!==-1" name="purchaseoutstockbill" style="height: 100%;">
				<purchaseoutstockbill-index />
			</el-tab-pane>
			<el-tab-pane label="工单" v-if="findChildren(107)!==-1" name="reconciliationcurrentworkorder" style="height: 100%;">
				<reconciliationcurrentworkorder-index />
			</el-tab-pane>
			<!-- 			<el-tab-pane label="预付款" v-if="findChildren(76)!==-1" name="purchasefinbill" style="height: 100%;">
				<purchasefinbill-index />
			</el-tab-pane> -->
			<!-- 			<el-tab-pane label="岗位信息" v-if="findChildren(16)!==-1" name="postjob" style="height: 100%;">
				<postjob-index />
			</el-tab-pane>
			<el-tab-pane label="职务级别" v-if="findChildren(17)!==-1" name="joblevel" style="height: 100%;">
				<joblevel-index />
			</el-tab-pane> -->
			<!-- 			<el-tab-pane label="人员信息" name="staff" style="height: 100%;">
				<staff-index />
			</el-tab-pane> -->
		</el-tabs>


	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import reconciliationcurrentIndex from './current/index.vue'
	import reconciliationIndex from './month/index.vue'
	import reconciliationbillIndex from './reconciliationbill/index.vue'
	import reconciliationpayIndex from './monthpay/index.vue'
	import purchasestockbillIndex from './purchasestockbill/index.vue'
	import purchaseoutstockbillIndex from './purchaseoutstockbill/index.vue'
	import reconciliationcurrentworkorderIndex from './reconciliationcurrentworkorder/index.vue'
	//import purchasefinbillIndex from './purchasefinbill/index.vue'
	// import postjobIndex from './postjob/index.vue'
	// import joblevelIndex from './joblevel/index.vue'
	// import staffIndex from './staff/index.vue'
	export default {
		props: {

		},
		data() {
			return {
				activeName: '',
				activeIndex: '',
				departmentChildren: []
			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			if (this.departmentChildren.length != 0) {
				this.activeName = this.departmentChildren[0].controller
				this.activeName = 'reconciliationbill'
			}
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			}
		},
		components: {
			reconciliationcurrentIndex,
			reconciliationIndex,
			reconciliationpayIndex,
			purchasestockbillIndex,
			purchaseoutstockbillIndex,
			reconciliationcurrentworkorderIndex,
			reconciliationbillIndex
			//purchasefinbillIndex
			// postjobIndex,
			// joblevelIndex,
			// staffIndex,

		}
	}
</script>